const actions = {
  
  LISTINGS_REPORTS_READ_BEGIN: 'LISTINGS_REPORTS_READ_BEGIN',
  LISTINGS_REPORTS_READ_SUCCESS: 'LISTINGS_REPORTS_READ_SUCCESS',
  LISTINGS_REPORTS_READ_ERR: 'LISTINGS_REPORTS_READ_ERR',

  LISTING_REPORT_DELETE_BEGIN: 'LISTING_REPORT_DELETE_BEGIN',
  LISTING_REPORT_DELETE_SUCCESS: 'LISTING_REPORT_DELETE_SUCCESS',
  LISTING_REPORT_DELETE_ERR: 'LISTING_REPORT_DELETE_ERR',

  LISTING_REPORT_READ_BEGIN: 'LISTING_REPORT_READ_BEGIN',
  LISTING_REPORT_READ_SUCCESS: 'LISTING_REPORT_READ_SUCCESS',
  LISTING_REPORT_READ_ERR: 'LISTING_REPORT_READ_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.LISTINGS_REPORTS_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.LISTINGS_REPORTS_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.LISTINGS_REPORTS_READ_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.LISTING_REPORT_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.LISTING_REPORT_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.LISTING_REPORT_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.LISTING_REPORT_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.LISTING_REPORT_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.LISTING_REPORT_READ_ERR,
      err,
    };
  },

};

export default actions;
